__turbopack_context__.v({
  "AlignCenter": "_54CCjq_AlignCenter",
  "BlueGreen": "_54CCjq_BlueGreen",
  "Container": "_54CCjq_Container",
  "Icon": "_54CCjq_Icon",
  "Left": "_54CCjq_Left",
  "LinkContainer": "_54CCjq_LinkContainer",
  "LinkText": "_54CCjq_LinkText",
  "LinkWrapper": "_54CCjq_LinkWrapper",
  "PinkBlue": "_54CCjq_PinkBlue",
  "PinkOrange": "_54CCjq_PinkOrange",
  "PinkPurple": "_54CCjq_PinkPurple",
  "PurpleBlue": "_54CCjq_PurpleBlue",
  "Right": "_54CCjq_Right",
  "Root": "_54CCjq_Root",
  "Tagline": "_54CCjq_Tagline",
  "Text": "_54CCjq_Text",
  "TitleBottom": "_54CCjq_TitleBottom",
  "TitleContainer": "_54CCjq_TitleContainer",
  "TitleTop": "_54CCjq_TitleTop",
  "Visible": "_54CCjq_Visible",
  "WhiteBackground": "_54CCjq_WhiteBackground",
});
